<template>
  <div id="app">
    <Head />
    <router-view />
    <ContactWay />
    <Footer />
  </div>
</template>
<script>

import * as api from "@/assets/api/api.js";
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";
import ContactWay from "@/components/ContactWay.vue";
import {postDataJxjy} from "@/assets/api/api.js";
import {Message} from "view-design";
export default {
  components: {
    Head,
    ContactWay,
    Footer,
  },
  data() {
    return {
      loopW: 0,
      nav: 0,
      dataInfo: "",
    };
  },
  mounted() {
	  this.isShowChromeTip()
    this.getSpecial();
    // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
    // window.onbeforeunload = function (e) {
    //   var storage = window.localStorage;
    //   storage.clear()
    // }

  },
  methods: {

    getSpecial(){
      //获取路由
      let route = this.$route;
      console.log(route);
      //判断路由是否等于special
      if(route.path == "/special"){
        //请求logo
        postDataJxjy("/jxjyapi/Tenpoint/getLogo", {specialType: route.query.special_type}).then((res) => {
          console.log(res, 888);
         if (res.code == false) {
           localStorage.setItem("special",null);
           //跳转
           this.$router.push({
             path: "/",
           });

          } else {
           //Json写入
           localStorage.setItem("special",JSON.stringify(res.data));
           console.log("写入成功")


           //跳转
           this.$router.push({
             path: "/",
           });
          }

        })
      }else {
        //判断缓存中special 是否存在
        if(!localStorage.getItem("special")){
          console.log(localStorage.getItem("special"));
          localStorage.setItem("special",null);
        }else {
          console.log(localStorage.getItem("special"),'缓存中的special');
        }
      }
    },

	  isShowChromeTip() {
		if(navigator.userAgent.toLowerCase().indexOf("chrome") == -1){
			 this.$Modal.error({
				title: '错误提示',
				content:'请使用谷歌浏览器,点击确认去下载谷歌浏览器',
				onOk: () => {
					window.open('https://www.google.cn/intl/zh-CN/chrome/','_blank');
				},
			});
		   }else{
		   }
	  }
  },
};
</script>
<style lang="scss">
body,
html {
  background: #f0f0f0 !important;
  font-family: Helvetica, STHeiti, Microsoft YaHei, Verdana, Arial, Tahoma,
    sans-serif;
  margin: 0;
  padding: 0;
  border: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  font-size: 100%;
  vertical-align: baseline;
}

ol,
ul {
  list-style: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

caption,
td,
th {
  font-weight: 400;
  vertical-align: middle;
}

blockquote,
q {
  quotes: none;
}

blockquote:after,
blockquote:before,
q:after,
q:before {
  content: "";
  content: none;
}

a img {
  border: none;
}

a {
  color: #07d;
  text-decoration: none;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary {
  display: block;
}

li {
  list-style: none;
}

html {
  position: relative;
}

body,
html {
  min-width: 1100px;
  color: #333;
  background: #fff;
  font-size: 14px;
  font-family: Microsoft YaHei, Helvetica, Pingfang SC, STHeiti, Verdana, Arial,
    Tahoma, sans-serif;
}

html,
body {
  background: #fff;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  background: #f0f0f0;
}

.contentCenter {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
}
button {
  cursor: pointer;
  border: none;
  outline: none;
}
.sw-container {
  width: 1200px;
  margin: 0 auto;
  .ivu-page-item-active {
    background: #222222;
    border-color: #222;
    a {
      color: #fff;
    }
  }
  .ivu-page-item-active a {
    color: #fff;
  }
  .ivu-page-item:hover {
    border-color: #222;
    a {
      color: #222;
    }
  }
  .ivu-page-next:hover,
  .ivu-page-prev:hover {
    border-color: #222;
    a {
      color: #222;
    }
  }
  .ivu-page-item-active:hover a {
    color: #fff;
  }
}

.common-nav {
  display: flex;
  height: 55px;
  line-height: 55px;
  font-size: 14px;
  color: #999;
  .s1 {
  }
  .s2 {
    margin: 0 10px;
  }
  .s3 {
    color: #161a21;
  }
}
/* 弹性布局 */

.display-flex {
  /* box */
  display: -webkit-box;
  /* 老版本语法: Chrome 4+,Safari, iOS, Android browser, older WebKit browsers. */
  display: -webkit-flex;
  /* 新版本语法: Chrome 21+,Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-box;
  /* 老版本语法: Firefox 17- */
  display: -moz-flex;
  /* Firefox 18+ */
  display: -ms-flexbox;
  /* 混合版本语法: IE 10 */
  display: flex;
  /* 新版本语法: Chrome 29+,IE 11+, Opera 12.1/17/18, Android 4.4+  Firefox 22+ */
}
/*从左至右*/

.flex-direction-row {
  /* box */
  -webkit-box-direction: normal;
  -webkit-box-orient: horizontal;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}
/*从上至下*/

.flex-direction-column {
  /* box */
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  box-orient: vertical;
  -moz-flex-direction: column;
  flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
}
/*交叉轴居中对齐*/

.align-items-center {
  /* box */
  -webkit-box-align: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
/*交叉轴居左对齐*/

.align-items-flex-start {
  /* box */
  -webkit-box-align: start;
  -moz-align-items: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  -ms-align-items: flex-start;
  -o-align-items: flex-start;
  align-items: flex-start;
}
/*交叉轴居右对齐*/

.align-items-flex-end {
  /* box */
  -webkit-box-align: end;
  -moz-align-items: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  -ms-align-items: flex-end;
  -o-align-items: flex-end;
  align-items: flex-end;
}
/*主轴居右*/

.justify-content-flex-end {
  /* box */
  -ms-flex-pack: end;
  -webkit-box-pack: end;
  -moz-justify-content: flex-end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}
/*主轴居左*/

.justify-content-center {
  /* box */
  -webkit-box-pack: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
}

.justify-content-space-between {
  /* box */
  -webkit-box-pack: justify;
  -moz-justify-content: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
}
/*主轴左右留白*/

.justify-content-space-around {
  /* box */
  -webkit-box-pack: justify;
  -moz-justify-content: space-around;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  -ms-justify-content: space-around;
  -o-justify-content: space-around;
}
/**元素换行**/

.flex-wrap {
  /* box */
  -webkit-box-lines: multiple;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}
/**元素不换行**/

.flex-nowrap {
  /* box */
  -webkit-box-lines: multiple;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  -moz-flex-wrap: nowrap;
  -o-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
/* self */

.flex-1 {
  /* self */
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

// 分页部分
.page {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 25px;
}
.page input {
  box-sizing: border-box;
}
.pageItem {
  .ivu-page-item-active {
    background: #000;
    border: 1px solid #000;
    a {
      color: #fff;
    }
  }
}
// 加载数据时的loding动画
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
// 测导航样式
.sidebar {
  width: 220px;
  background: #fff;
  float: left;
  li:last-child .inner {
    border: none;
  }
  li {
    cursor: pointer;
    overflow: hidden;
    color: rgba(102, 102, 102, 1);
    .inner {
      padding: 17px 22px;
      border-bottom: 1px dashed #d3d3d3;
    }

    span {
      position: relative;
      line-height: 15px;
      padding-left: 15px;
    }
    span::after {
      position: absolute;
      top: 0%;
      left: 0;
      content: "+";
    }
  }
  li.active {
    .inner {
      border-bottom: 1px dashed transparent;
    }
    background: #31ae59;
    color: #fff;
  }
}
// 左边带绿色竖线的标题
.publicTitle {
  margin-bottom: 10px;
  padding: 15px 0;
  border-bottom: 1px solid #f5f2f5;
  margin-bottom: 15px;
  .h5 {
    img {
      vertical-align: middle;
    }
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
  }
}
// 您所在位置样式
.currentLocation {
  padding-top: 20px;
  padding-bottom: 20px;
  li {
    padding-left: 10px;
    padding-right: 10px;
    line-height: 16px;
    span {
      color: rgba(153, 153, 153, 1);
    }
    border-left: 1px solid rgba(153, 153, 153, 1);
  }
  li:first-child {
    border-left: none;
    padding-left: 0px;
  }
  li:last-child {
    span {
      color: #222;
    }
  }
}
</style>
